import { render, staticRenderFns } from "./ConfirmationTypeFilter.vue?vue&type=template&id=56fa3876&scoped=true"
import script from "./ConfirmationTypeFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmationTypeFilter.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ConfirmationTypeFilter.vue?vue&type=style&index=0&id=56fa3876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa3876",
  null
  
)

export default component.exports